
/**
 * 상세 에러 정보
 * @nullable
 */
export type InternalServerErrorResponseErrorDetails = { [key: string]: unknown } | null;
